var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c("gg-card-header", [_vm._v(" Website Type ")]),
      _c(
        "gg-card-text",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c("p", [
                    _vm._v(
                      "Let’s get started by choosing the type of website you would like to create."
                    )
                  ]),
                  _c(
                    "v-radio-group",
                    {
                      model: {
                        value: _vm.websiteType,
                        callback: function callback($$v) {
                          _vm.websiteType = $$v
                        },
                        expression: "websiteType"
                      }
                    },
                    _vm._l(_vm.ssWebsiteTypes, function(wt, i) {
                      return _c("v-radio", {
                        key: "wtr-".concat(i),
                        attrs: {
                          label: wt,
                          value: wt,
                          color: "primary"
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }